module.exports = __webpack_public_path__ + "img/dach_22.348c6ef0.webp";